export enum PromisedPaymentTypeEnum {
  ACH = 1,
  Manual = 2,
  Payroll = 3,
}
